import Alpine from 'alpinejs'
Alpine.data('navigation', () => ({
    show: true,
    isOpen: false,

    init() {
        const links = this.$el.querySelectorAll('.scrollactive-item')
        const sections = new Map()

        links.forEach(link => {
            const href = link.getAttribute('href')
            const hash = href.includes('#') ? href.substring(href.indexOf('#')) : null
            if (hash) {
                const section = document.querySelector(hash)
                if (section) sections.set(section, hash)
            }
        })

        if (sections.size === 0) return

        const setActive = (hash) => {
            links.forEach(link => {
                const linkHref = link.getAttribute('href')
                link.classList.toggle('is-active', linkHref === hash || linkHref === '/' + hash)
            })
        }

        this._observer = new IntersectionObserver((entries) => {
            for (const entry of entries) {
                if (entry.isIntersecting) {
                    setActive(sections.get(entry.target))
                    break
                }
            }
        }, { rootMargin: '-80px 0px -60% 0px' })

        for (const section of sections.keys()) this._observer.observe(section)

        if (window.location.hash) {
            setActive(window.location.hash)
        }
    },

    destroy() {
        this._observer?.disconnect()
    },

    toggle() {
        this.isOpen = !this.isOpen
    },
    close() {
        this.isOpen = false
    },
    open() {
        this.isOpen = true
    },
}))
